import { c as _c } from "react/compiler-runtime";
import { getEntitiesByFpIdLinkedBankAccountsOptions } from '@onefootprint/fetch-dashboard';
import { useQuery } from '@tanstack/react-query';
import formatAccount from '../utils/format-account';
import formatLink from '../utils/format-link';
const useLinkedBankAccounts = id => {
  const $ = _c(5);
  let t0;
  if ($[0] !== id) {
    t0 = getEntitiesByFpIdLinkedBankAccountsOptions({
      path: {
        fpId: id
      }
    });
    $[0] = id;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = !!id;
  let t2;
  if ($[2] !== t0 || $[3] !== t1) {
    t2 = {
      ...t0,
      enabled: t1,
      select: _temp3
    };
    $[2] = t0;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return useQuery(t2);
};
export default useLinkedBankAccounts;
function _temp(account) {
  return formatAccount(account as Record<string, unknown>);
}
function _temp2(link) {
  return formatLink(link as Record<string, unknown>);
}
function _temp3(t0) {
  const {
    accounts,
    links
  } = t0;
  return {
    accounts: Object.values(accounts).map(_temp),
    links: Object.values(links).map(_temp2)
  };
}